module.exports = __webpack_public_path__ + "static/img/bukowski-cameron.e4badb1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bukowski-cameron.jpg
// module id = 9v69
// module chunks = 0